import customSelect from "custom-select";
import { Core } from "Components/core";

export class Select extends Core {
  constructor(domElem) {
    super(domElem, Select.className);

    this._control = domElem.querySelector(
      `.${Select.className}${Select.ELEM_DELIM}control`
    );
    this._val = this._control.value;
    this._control.addEventListener("change", this._onChange.bind(this));
  }

  getName() {
    return this._control.getAttribute("name");
  }

  getVal() {
    return this._val;
  }

  setVal(val) {
    this._control.value = val;
    return this;
  }

  _onChange(e) {
    (e.detail || {}).target == this || e.stopPropagation(); // don't stop custom event

    const val = this._control.value;

    if (val != this.getVal()) {
      this._val = val;

      this._emit("change");
    }
  }

  static className = "select";
  static instances = {};

  static init() {
    customSelect(".select__control").forEach((el) => {
      const select = el?.select;
      if (select) {
        const view = select.getAttribute("data-view"),
          mix = el.select.getAttribute("data-mix"),
          classList = el.container.classList;

        view
          ? classList.add("select", `select_view_${view}`)
          : classList.add("select");

        mix && classList.add(mix);

        el.value === "placeholder" && (el.select.value = "");
      }
    });

    document.querySelectorAll(`.${Select.className}`).forEach((el) => {
      return new Select(el);
    });
  }
}
